import { Box, Button, IconButton, InputBase, MenuItem, Paper, Popover, Select, Typography, useTheme } from '@mui/material'
import React, { useRef, useState } from 'react'
import { debounce, formatDate, Icons } from '../../../utils/utilities'
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { useSearchParams } from 'react-router-dom'
import DataLoadingSpinner from '../../common/DataLoadingSpinner'
import api from '../../../service/api'
import dayjs from 'dayjs'

const FilterBar = ( { statsView, availableModules, disabled } ) => {

    const [filteredUsers, setFilteredUsers] = useState( [] )
    const [loadingUsers, setLoadingUsers] = useState( false )
    const [userSearchValue, setUserSearchValue] = useState( '' )
    const [datePickerOpenState, setDatePickerOpenState] = useState( false )

    const [searchParams, setSearchParams] = useSearchParams( { filterLevel: "error" } )
    const filterUser = searchParams.get( "filterUser" ) || ""
    const filterUserId = searchParams.get( "filterUserId" ) || ""
    const filterLevel = searchParams.get( "filterLevel" ) || ""
    const filterDate = searchParams.get( "filterDate" ) || ""
    const filterModule = searchParams.get( "filterModule" ) || ""

    const filtersApplied = Boolean( filterDate || filterUserId || filterLevel || filterModule )

    const { palette, border } = useTheme()

    const userSearchContainerRef = useRef()

    const setSearchParamValue = ( key, value ) => {
        setSearchParams( prev => {
            const newParams = new URLSearchParams( prev )
            if ( value )
                newParams.set( key, value )
            else
                newParams.set( key, "" )
            return newParams
        }, { replace: true } )
    }

    const searchUsers = debounce( "searchUsers", async ( searchText ) => {
        try {
            if ( searchText.length >= 5 ) {
                setLoadingUsers( true )
                const { data } = await api.logging.filterUsers( { filterText: searchText } )
                setFilteredUsers( data.data )
            }
        } catch ( err ) {
            console.log( err )
        } finally {
            setLoadingUsers( false )
        }
    }, 1000 )


    const handleUserSearchChange = ( e ) => {
        setUserSearchValue( e.target.value )
        searchUsers( e.target.value )
    }

    const handleDateChange = ( e ) => {
        setDatePickerOpenState( false )
        setSearchParamValue( 'filterDate', dayjs( e ).format( "YYYY-MM-DD" ) )
    }

    const removeUserFilter = () => {
        setSearchParamValue( "filterUser" )
        setSearchParamValue( "filterUserId" )
    }

    const closeFilteredUsersList = () => {
        setFilteredUsers( [] )
        setUserSearchValue( "" )
    }

    const fetchUserLogs = ( user ) => {
        setSearchParams( prev => {
            const newParams = new URLSearchParams( prev )
            newParams.set( "filterUser", user.employee_name || user.student_name || user.user_name )
            newParams.set( "filterUserId", user.user_id )
            return newParams
        }, { replace: true } )
        setUserSearchValue( '' )
        setFilteredUsers( [] )
    }

    const removeFilters = () => {
        setSearchParams( prev => {
            const newParams = new URLSearchParams( prev )
            newParams.set( 'filterDate', '' )
            newParams.set( 'filterUserId', '' )
            newParams.set( 'filterUser', '' )
            newParams.set( 'filterLevel', '' )
            newParams.set( 'filterModule', '' )
            return newParams
        }, { replace: true } )
    }

    console.log( filterLevel )


    return (
        <Box padding="10px" justifyContent="space-between" display="flex" flexWrap="wrap" gap="10px">
            <Box display="flex" flexWrap="wrap" gap="10px">

                <Box display="flex" gap="10px" alignItems="center" sx={{ border: border[1], overflow: "clip", borderRadius: "20px", ":hover": { borderColor: palette.common.font } }}>
                    <Box sx={{ cursor: "pointer", }} position="relative">
                        <Button disableFocusRipple disabled={disabled} onClick={() => setDatePickerOpenState( p => true )} disableRipple disableTouchRipple sx={{ paddingX: "15px", color: palette.common.font, transition: "none", ":hover": { borderColor: palette.common.font } }} startIcon={Icons.default.Calendar} color="greyed">
                            {formatDate( filterDate, { format: "DD-MM-YYYY" } ) || formatDate( new Date(), { format: "DD-MM-YYYY" } )}
                        </Button>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                open={datePickerOpenState}
                                onClose={() => setDatePickerOpenState( false )}
                                id="startdatetime"
                                slotProps={{
                                    textField: {
                                        onClick: () => setDatePickerOpenState( true )
                                    }
                                }}
                                slots={{
                                    openPickerButton: () => null,
                                }}
                                sx={{ opacity: 0, position: "absolute", inset: 0, fontSize: "14px", '& input': { padding: "0px 10px", cursor: "pointer" } }}
                                // value={dayjs( endDateTime )}
                                views={['year', 'month', 'day']}
                                onChange={handleDateChange}
                            />
                        </LocalizationProvider>
                    </Box>
                    {Boolean( filterDate ) && <IconButton disabled={disabled} onClick={() => setSearchParamValue( 'filterDate' )} disableFocusRipple disableRipple disableTouchRipple >
                        {Icons.default.CancelIcon}
                    </IconButton>}
                </Box>
                {!statsView && <Paper
                    ref={userSearchContainerRef}
                    component="form"
                    elevation={0}
                    sx={{
                        borderRadius: "20px",
                        border: border[1],
                        padding: '2px 4px',
                        bgcolor: palette.form.inputBg,
                        display: 'flex',
                        alignItems: 'center',
                        width: 230
                    }}
                >
                    <InputBase
                        disabled={disabled}
                        value={userSearchValue}
                        onChange={handleUserSearchChange}
                        sx={{ ml: 1, flex: 1, background: "none" }}
                        placeholder="Search Users By Acahrya ID..."
                        inputProps={{ 'aria-label': 'search google maps' }}
                    />
                </Paper>}
                {!statsView && <Popover
                    slotProps={{ paper: { sx: { maxHeight: "200px" }, className: "slim-custom-scrollbar" } }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }} anchorEl={userSearchContainerRef.current}
                    onClose={closeFilteredUsersList}
                    open={loadingUsers || filteredUsers.length > 0}
                >
                    <Box width={400}>
                        <Typography borderBottom={border[1]} padding="10px">{loadingUsers ? "Searching..." : `Found ${filteredUsers.length} users`}</Typography>
                        {!loadingUsers && filteredUsers.map( user => (
                            <Box onClick={() => fetchUserLogs( user )} borderBottom={border[1]} sx={{ cursor: "pointer", ":hover": { background: palette.secondary.light + "22" } }} padding="5px 10px" key={user.session_id}>
                                <Typography display="block" variant='subtitle2' fontSize="13px"><em>{user.employee_name || user.student_name || user.user_name}</em></Typography>
                                <Typography display="block" variant='subtitle2' color='textSecondary' fontSize="12px"><em>{user.user_id}</em></Typography>
                                <Typography display="block" variant='subtitle2' color='textSecondary' fontSize="10px">{user.institute}{user.department ? `, ${user.department}` : ""}{`${user.year ? `, Y:${user.year}` : ""} ${user.sem ? `, S:${user.sem}` : ""}`} </Typography>
                            </Box>
                        ) )}
                        {loadingUsers && <DataLoadingSpinner waitingMessage="Loading Users..." />}
                    </Box>
                </Popover>}
                {!statsView && filterUserId && <Box display="flex" border={border[1]} alignItems="center" gap="5px" sx={{ borderRadius: "20px", padding: "2px 10px", bgcolor: palette.contentBg, borderColor: palette.common.font }}>
                    <Typography variant="subtitle2">{filterUser}</Typography>
                    <IconButton disabled={disabled} onClick={removeUserFilter} size="small" >{Icons.default.CancelIcon}</IconButton>
                </Box>}
                {!statsView && !filterLevel && <Select disabled={disabled} displayEmpty sx={{ borderRadius: "20px", fontWeight: "500" }} onChange={e => setSearchParamValue( 'filterLevel', e.target.value )} value={filterLevel || "all"} size="small">
                    <MenuItem dense disabled value="all">Level</MenuItem>
                    <MenuItem dense value="info">Info</MenuItem>
                    <MenuItem dense value="error">Error</MenuItem>
                </Select>}
                {!statsView && filterLevel && <Box display="flex" border={border[1]} alignItems="center" gap="5px" sx={{ borderRadius: "20px", borderColor: palette.common.font }}>
                    <Typography padding="2px 10px" variant="subtitle2" textTransform="capitalize" >{filterLevel}</Typography>
                    <IconButton disabled={disabled} onClick={() => setSearchParamValue( 'filterLevel', '' )} size="small" >{Icons.default.CancelIcon}</IconButton>
                </Box>}
                {!statsView && !filterModule && <Select disabled={disabled} displayEmpty onChange={e => setSearchParamValue( 'filterModule', e.target.value )} MenuProps={{ slotProps: { paper: { sx: { maxHeight: "200px" }, className: "slim-custom-scrollbar" } } }} sx={{ borderRadius: "20px", textTransform: "capitalize", fontWeight: "500" }} value={filterModule || ""} size="small">
                    <MenuItem disabled dense value="">Module</MenuItem>
                    {availableModules.map( module => (
                        <MenuItem dense key={module} value={module} sx={{ textTransform: "capitalize" }}>{module?.toLowerCase()?.replace( /_/g, " " )}</MenuItem>
                    ) )}
                </Select>}
                {!statsView && filterModule && <Box display="flex" border={border[1]} alignItems="center" gap="5px" sx={{ borderRadius: "20px", borderColor: palette.common.font }}>
                    <Typography padding="2px 10px" variant="subtitle2" textTransform="capitalize" >{filterModule}</Typography>
                    <IconButton disabled={disabled} onClick={() => setSearchParamValue( 'filterModule' )} size="small" >{Icons.default.CancelIcon}</IconButton>
                </Box>}
                {filtersApplied && <Button variant='contained' disabled={disabled} sx={{ borderRadius: "20px", textTransform: "capitalize" }} color="errorMessage" startIcon={Icons.small.CloseIcon} disableElevation onClick={removeFilters}>Remove Filters</Button>}
            </Box>
        </Box>
    )
}

export default FilterBar
